import React, { useMemo } from 'react';
import ReactTable from '../../../../../components/table/ReactTable';
import useCustomTable from '../../../../../hooks/common/useCustomTable';
import setSellerTableColumns from './setSellerTableColumns';
import TableToolbar from '../../../../../components/table/TableToolbar';
import cx from 'classnames';
import './ReactAccountSellerList.scss';
import Pagination from '../../../../../components/table/ReactTablePagination/ReactTablePagination';

const ReactAccountSellerList = (props) => {
  const {
    accountSellerList,
    onClickSortOption,
    onChangeFilterOption,
    onClickResetFilter,
    onClickSellerListDownload,
    onChangePaginationOption,
    paginationOption,
    sortOption,
    currentPage,
    setCurrentPage,
  } = props;

  const { total } = accountSellerList;
  const columns = useMemo(() => setSellerTableColumns(onChangeFilterOption), [onChangeFilterOption]);
  const tableInstance = useCustomTable(columns, accountSellerList?.data);

  return (
    <div className={cx('table-with-toolbar')}>
      <TableToolbar
        total={total}
        hasUserCheckBox={false}
        hasFilter={true}
        hasExelDownloadButton={true}
        onClickExcelDownload={onClickSellerListDownload}
        onClickResetFilter={onClickResetFilter}
      />
      <div className="account-user-list-wrap">
        <div className="account-user-list">
          <ReactTable
            tableInstance={tableInstance}
            onClickSortOption={onClickSortOption}
            sortOption={sortOption}
            isMultiSortable={false}
            emptyText="요청하신 검색 필터로 검색된 판매자 리스트가 없습니다."
          />
        </div>
        <Pagination
          onChangePaginationOption={onChangePaginationOption}
          paginationOption={paginationOption}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          total={total || 0}
        />
      </div>
    </div>
  );
};
export default ReactAccountSellerList;
